import CardTable from "@components/cardTable/CardTable";
import { Link } from "@material-ui/core";
import Delete from "@material-ui/icons/Delete";
import Edit from "@material-ui/icons/Edit";
import { useDeleteLandingPage } from "@store/actions/landingPageActions";
import { useConfirmationContext } from "providers/ConfirmationProvider";
import { useNotificationContext } from "providers/NotificationProvider";
import React from "react";
import { Link as RouterLink, useHistory } from "react-router-dom";

function LandingPagesTable({ landingPages }) {
  const history = useHistory();
  const [deleteLandingPage, { loading }] = useDeleteLandingPage();
  const { openConfirmation, closeConfirmation } = useConfirmationContext();
  const { showNotification } = useNotificationContext();

  const onDelete = ({ id, name }) => {
    openConfirmation({
      title: `Delete ${name}`,
      body: `Deleting ${name} can not be undone, are you sure you want to continue?`,
      loading: () => loading,
      callback: () =>
        deleteLandingPage({
          variables: {
            id,
          },
        }).then(() => {
          showNotification(`${name} Deleted!`);
          closeConfirmation();
        }),
    });
  };
  // [
  //   openConfirmation,
  //   loading,
  //   deleteLandingPage,
  //   showNotification,
  //   closeConfirmation,
  // ]
  // );

  return (
    <CardTable
      tableHead={["name", "oneLiner"]}
      tableData={landingPages}
      actions={[
        {
          icon: <Edit color="primary" />,
          fn: ({ id }) => history.push(`/landing-pages/${id}/edit`),
        },
        {
          icon: <Delete color="secondary" />,
          fn: onDelete,
        },
      ]}
    />
  );
}

export default LandingPagesTable;
